import { NgModule } from '@angular/core'
import { FloResponsiveImageDirective } from './responsive-image.directive'

@NgModule({
  exports: [FloResponsiveImageDirective],
  declarations: [FloResponsiveImageDirective]
})
export class ResponsiveImageModule {}
